<template>
  <div id="app" class="app-container" :class="currentLang == 'en' ? 'en-container' : ''">
    <router-view v-if="isRouterAlive" :currentLang="currentLang" />
    <div class="link-wrap" v-if="show">
      <SingleCycleDisplay class="cycleDisplayCn" :texts="[$t('message.tools.msg4'), $t('message.tools.msg6')]" :buttons="[$t('message.tools.msg5'), $t('message.tools.msg7')]" :duration="2400" />
      <i class="el-icon-close" @click="show = false"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SingleCycleDisplay from './components/CycleDisplay.vue';

export default {
  name: 'App',
  provide() {
    return {
      reloadApp: this.reloadApp,
      changeAppLanguage: this.changeAppLanguage,
      toVisualBudgetCenter: this.toVisualBudgetCenter,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      currentLang: globalUrl.VUE_LANG,
      show: true,
    };
  },
  components: {
    SingleCycleDisplay,
  },
  created() {
    this.setLanguage();
    // axios({
    //   method: 'get',
    //   url: 'https://user.xpirory.cn/xpiory/api/pay/judgeMethod',
    // }).then(res => {
    //   let host = location.host.substring(location.host.lastIndexOf('.'));
    //   if (host.indexOf(':') < 0) {
    //     if (res.data.data) {
    //       if (host != '.cn') {
    //         window.location.href = 'https://www.xpirory.cn';
    //       }
    //     } else {
    //       if (host != '.com') {
    //         window.location.href = 'https://www.xpirory.com';
    //       }
    //     }
    //   }
    // });
  },
  methods: {
    // 设置语言
    setLanguage() {
      // if (this.$vueCookies.get("lang") == undefined) {
      //   this.$vueCookies.set("lang", globalUrl.VUE_LANG || "en");
      // }
      if (location.host.substring(location.host.lastIndexOf('.')) == '.cn') {
        // cn域名默认中文
        this.$i18n.locale = 'cn';
        this.currentLang = 'cn';
      } else {
        this.$i18n.locale = navigator.language == 'zh-CN' ? 'cn' : 'en';
        this.currentLang = navigator.language == 'zh-CN' ? 'cn' : 'en';
      }
    },
    // 切换语言
    changeAppLanguage(lang) {
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
      this.currentLang = lang;
      this.reloadApp();
    },
    reloadApp() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    // 立即试用-立即体验
    toVisualBudgetCenter() {
      if (localStorage.user_name) {
        // this.$router.push("/visualBudgetCenter");
      } else {
        this.$confirm(this.$t('message.header.loginTips'), this.$t('message.tips'), {
          type: 'warning',
        }).then(() => {
          this.$router.push('/contact');
        });
      }
    },
  },
  mounted() {
    this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    window.addEventListener('resize', () => {
      // 你的逻辑代码
      this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    });
  },
};
</script>

<style lang="scss">
/*页面开始*/
html,
body,
#app {
  height: 100%;
  width: 100%;
}
.link-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 100, 255, 0.8);
  z-index: 9999;
  i {
    font-size: 20px;
    position: fixed;
    right: 40px;
    bottom: 30px;
    cursor: pointer;
  }
  .cycleDisplayCn {
    font-size: 18px;
    
    .el-button {
      margin-left: 95px;
    }
  }
}
</style>
